import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Stepper,
  Step,
  StepLabel,
  Typography,
  Box
} from "@mui/material";
import { ArrowBack, Close } from "@mui/icons-material";
import MUIBasedPortfolio from "./MUIBasedPortfolio";
import BotUserProfile from "../BotUserProfile";
import RealUserProfile from "../RealUserProfile";

const InitiateModal = ({ open, onClose }) => {

  const [step, setStep] = useState(1);

  const steps = ['Search User', 'Select Bot', 'Initiate Chat'];
 const [openProfile, setOpenProfile] = useState({status:false,details:null});
 const [openRealProfile, setOpenRealProfile] = useState(false);
 const [selectedUser, setSelectedUser] = useState(null);

  const toggleDrawer = (status,details=null) => () => {
    setOpenProfile({status,details});
  };
  const toggleRealUserDrawer = (open,user) => () => {
    setOpenRealProfile(open);
    setSelectedUser(user)
  };

  useEffect(()=>{
    setStep(1)
  },[open])

  
  return (
    <>
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="lg"
      scroll="paper"
      PaperProps={{ sx: { borderRadius: 2 } }}
    >
      {/* --- MOVED HEADER HERE --- */}
      <Box
        sx={{
          p: 3,
          position: "sticky",
          top: 0,
          zIndex: 10,
          backgroundColor: "#fff",
          borderBottom: "1px solid #ddd",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          {Boolean(step!==1) &&<IconButton onClick={() => step === 1 ? onClose() : setStep(step - 1)}>
            <ArrowBack />
          </IconButton>}

          <Box sx={{ flex: 1 }}>
            <Typography variant="h5" sx={{ fontWeight: 600 }}>
              Initiate New Chat
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Search for a user to start a conversation
            </Typography>
          </Box>

          <IconButton onClick={onClose} sx={{ bgcolor: "grey.300" }}>
            <Close />
          </IconButton>
        </Box>

        {/* Stepper */}
        {/* <Stepper activeStep={step - 1} sx={{ mt: 2 }} >
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel><Typography fontSize="12px">{label}</Typography></StepLabel>
            </Step>
          ))}
        </Stepper> */}
       <Stepper
  activeStep={step - 1}
  sx={{
    mt: 2,

    // COMPLETED step icon color
    '& .MuiStepIcon-root.Mui-completed': {
      color: '#BF8500', // green
    },

    // ACTIVE step icon color
    '& .MuiStepIcon-root.Mui-active': {
      color: '#ff9800', // orange
    },

    // INACTIVE (default) step icon color
    '& .MuiStepIcon-root': {
      color: '#4A5565', // grey 
    },

    // ACTIVE label color
    '& .MuiStepLabel-label.Mui-active': {
      color: '#ff9800 !important',
      fontWeight: 600,
    },
    '& .Mui-active .MuiStepConnector-line':{ borderColor: '#BF8500 !important'},

    // COMPLETED label color
    '& .MuiStepLabel-label.Mui-completed': {
      color: '#BF8500 !important',
      fontWeight: 600,
    },

    // INACTIVE label color
    '& .MuiStepLabel-label': {
      color: '#9e9e9e',
      fontSize: '12px',
    },
  }}
>
  {steps.map((label) => (
    <Step key={label}>
      <StepLabel>
        <Typography fontSize="12px">{label}</Typography>
      </StepLabel>
    </Step>
  ))}
</Stepper>

      </Box>

      {/* BODY */}
      <DialogContent
        dividers
        sx={{ maxHeight: "70vh", overflowY: "auto" }}
      >
        <MUIBasedPortfolio
            isModalOpen={open}
           step={step}
      setStep={setStep}
      onClose={onClose}
    onBotClick={(_,bot) => toggleDrawer(true,bot)()}
  onRealUserClick={(_,user) => toggleRealUserDrawer(true, user)()}
        /> 
      </DialogContent>
     
    </Dialog>
     <BotUserProfile open={openProfile?.status} toggleDrawer={toggleDrawer} selectedBot={openProfile?.details}/>
     <RealUserProfile open={openRealProfile} toggleDrawer={toggleRealUserDrawer} userData={selectedUser}/>
      </>
  );
};

export default InitiateModal;
